// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"00dbe2d5","448":"500f8e79"}[chunkId] + ".chunk.js";
};